import Vue from 'vue'

export function getUserLogList(data) {
    return Vue.axios({
        url: '/api/user_log/list',
        method: 'get',
        params: {...data}
    })
}

export function deleteUserLog(id) {
    return Vue.axios({
        url: '/api/user_log/delete',
        method: 'get',
        params: {id}
    })
}
